import PropTypes from 'prop-types';
import { useState, useEffect, useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Button, Toast } from 'react-weui';
import Dialog from '@material-ui/core/Dialog';
// import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { formatDateTime } from '../lib/formatter.ts';
import WorkflowService from 'services/workflow2';
import { ActionContext } from 'actions/context';
import ModalService from 'services/modal';
import './workflowStatus.css';

const styles = {
  paper: {
    margin: '10px',
    width: '90vw'
  }
};
/**
 *  审批环节 && 审批列表组件
 *
 */
function WorkflowStatus(props) {
  const { classes, companyCode, id, workflow, detail } = props;
  const { state, dispatch } = useContext(ActionContext);
  const [showInfo, setShowInfo] = useState(false);

  //初始化工作流（获取单据详情后调用）
  function initWorkflow() {
    workflow.arrStatus = [];
    if (workflow.wfmCode) {
      ModalService.showLoading(dispatch);
      WorkflowService.init(companyCode, workflow, id, true).then(rs => {
        if (workflow.isActive) {
          WorkflowService.getStatus(companyCode, [detail], workflow, true).then(
            () => {
              // 生成审批记录列表
              WorkflowService.createRecordList(detail, workflow).then(() => {
                setShowInfo(true);
                ModalService.hideLoading(dispatch);
              });
              // WorkflowService.getOaUrl(
              //   companyCode,
              //   this.pageBillType,
              //   id,
              //   workflow
              // );
            }
          );
        } else {
          ModalService.hideLoading(dispatch);
        }
      });
    }
  }

  let statusName = workflow?.arrStatus?.map(item => {
    if (Array.isArray(item.arrStatusName) && item.arrStatusName.length > 0) {
      return (
        <span key="0" className="m-flex-box m-flex-item">
          <span key="0">
            {item.arrStatusName[item.arrStatusName.length - 1]}
          </span>
          {item.viewDetailPermissionFlag === 1 && (
            <Button
              type="default"
              key="1"
              onClick={() => {
                initWorkflow();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              详情
            </Button>
          )}
        </span>
      );
    } else {
      return '';
    }
  });

  return (
    <span>
      {statusName}
      <Dialog
        classes={{ paper: classes.paper }}
        open={showInfo}
        aria-labelledby="form-dialog-title"
      >
        <h5>审批流程</h5>

        <DialogContent>
          <div className="scrollbar workflow">
            {workflow.recordList &&
              workflow.recordList.map((item, m) => (
                <div className="workflow-item" key={m}>
                  <div className="node-name">{item.nodeName}</div>

                  {!item.wfnXkNo && (
                    //  <!-- 送审 -->
                    <div className="node-content">
                      {item.applyCheckFlag === 1 && [
                        <div key="checkUserName" className="node-item">
                          送审人：{item.checkUserName}
                        </div>,
                        <div key="checkDate" className="node-item">
                          送审时间：{formatDateTime(item.checkDate)}
                        </div>,
                        <div key="checkDesc" className="node-item">
                          送审说明：{item.checkDesc}
                        </div>
                      ]}
                      {item.applyCheckFlag === 0 && (
                        <div key="checkUserName" className="node-item">
                          待送审
                        </div>
                      )}
                      <i className="icon-confirm-fill green"></i>
                    </div>
                  )}
                  {item.wfnXkNo && [
                    //  <!-- 审批关 -->
                    item?.recordList?.length > 0 && item.multiCheck === 0 && (
                      //  <!-- 已审批（单人） -->
                      <div
                        key="single"
                        className={
                          item.status === 0
                            ? 'node-content red'
                            : 'node-content'
                        }
                      >
                        <div className="node-item">
                          审批人：{item.recordList[0].optName}
                        </div>
                        <div className="node-item">
                          审批时间：
                          {formatDateTime(item.recordList[0].auditTime)}
                        </div>
                        <div className="node-item">
                          审批意见：{item.recordList[0].auditDesc}
                        </div>
                        {item.status !== 0 && (
                          <i className="icon-confirm-fill"></i>
                        )}
                        {item.status === 0 && (
                          <i className="icon-error-fill"></i>
                        )}
                      </div>
                    ),
                    item.recordList?.length > 0 && item.multiCheck === 1 && (
                      //<!-- 已审批（会签） -->
                      <div key="multi" className="node-content">
                        <div className="node-item">会签</div>

                        {item.recordList.map((row, j) => (
                          <div key={j} className="sub-node">
                            <div className="node-item">
                              审批人：{row.optName}
                              {row.auditStatus !== 0 && (
                                <i className="icon-confirm-fill"></i>
                              )}
                              {row.auditStatus === 0 && (
                                <i className="icon-error-fill"></i>
                              )}
                            </div>
                            <div className="node-item">
                              审批时间：{formatDateTime(row.auditTime)}
                            </div>
                            <div className="node-item">
                              审批意见：{row.auditDesc}
                            </div>
                          </div>
                        ))}

                        {item.status !== 0 && (
                          <i className="icon-confirm-fill"></i>
                        )}
                        {item.status === 0 && (
                          <i className="icon-error-fill"></i>
                        )}
                      </div>
                    ),
                    item.skipFlag === 1 && (
                      //<!-- 跳关 -->
                      <div key="skip" className="node-content">
                        <div className="node-item">跳过</div>
                        {item.status !== 0 && (
                          <i className="icon-confirm-fill"></i>
                        )}
                        {item.status === 0 && (
                          <i className="icon-error-fill"></i>
                        )}
                      </div>
                    ),
                    !item.recordList?.length > 0 && item.skipFlag !== 1 && (
                      //<!-- 未审批 -->
                      <div
                        key="unapprove"
                        className={
                          item.billWfnFlag === 1
                            ? 'node-content blue'
                            : 'node-content gray'
                        }
                      >
                        <div className="node-item">
                          审批人：
                          {item?.authList?.map((auth, k) => (
                            <span key={k}>
                              {k > 0 && <span>、</span>} {auth.optName}
                            </span>
                          ))}
                        </div>
                        <i className="icon-confirm-fill"></i>
                      </div>
                    )
                  ]}
                </div>
              ))}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className="u-btn u-btn_primary"
            onClick={() => {
              setShowInfo(false);
            }}
          >
            关闭
          </Button>
        </DialogActions>
      </Dialog>
    </span>
  );
}

WorkflowStatus.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(WorkflowStatus);
